module.exports = __webpack_public_path__ + "static/media/dipp-mark.5a255275.svg";